import HistorySingleton from '../records/HistorySingleton';
export const push = (...args) => () => {
  HistorySingleton().instance().push(...args);
};